/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {LicenseFeature} from '../models/LicenseFeature';

export interface GetDefaultLicenseFeatures$Request {
    licenseTypeCode: string;
    accountId: number;
}

export interface GetDefaultLicenseFeatures$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDefaultLicenseFeaturesRequest = createAction<PayloadData<void, GetDefaultLicenseFeatures$Request>>('GET_DEFAULT_LICENSE_FEATURES__GET_DEFAULT_LICENSE_FEATURES__REQUEST');
export const getDefaultLicenseFeaturesSuccess = createAction<PayloadData<Array<LicenseFeature>, GetDefaultLicenseFeatures$Request>>('GET_DEFAULT_LICENSE_FEATURES__GET_DEFAULT_LICENSE_FEATURES__SUCCESS');
export const getDefaultLicenseFeaturesFailure = createAction<PayloadData<Error, GetDefaultLicenseFeatures$Request, true>>('GET_DEFAULT_LICENSE_FEATURES__GET_DEFAULT_LICENSE_FEATURES__FAILURE');

export const getDefaultLicenseFeaturesActions = [
    getDefaultLicenseFeaturesRequest,
    getDefaultLicenseFeaturesSuccess,
    getDefaultLicenseFeaturesFailure
] as const;

/**
 * @param {string} meta.licenseTypeCode License Type Code
 * @param {number} meta.accountId Account id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDefaultLicenseFeatures = (meta: GetDefaultLicenseFeatures$Request, config?: GetDefaultLicenseFeatures$Config) => {
    const TRANSPORT_GET_PARAMS = {
        licenseTypeCode: meta.licenseTypeCode,
        accountId: meta.accountId,
    };
    return {
        CALL_API: {
            types: getDefaultLicenseFeaturesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/license-features/default`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

